/* ---------- Assign User  component ------------------

    -   This component is used to assign a user to a SHE Pack. 
*/

// ------------------- React Component --------------------------
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// ------------------------- Application Components/functions -----------------



// Application component - 
import ToastError from "../../../toasterscomponents/ToastError";
import CreatedSuccessfullToaster from "../../../toasterscomponents/manageusersToaster/createdSuccessfullToaster";

// --------------------------- Styles --------------------------------

// styles - css 
import '../../../../assets/css/ManageUsers.css';

// styles - icons 
import { MdAssignmentAdd } from "react-icons/md";

import { LiaSpinnerSolid } from "react-icons/lia";

import blueKbcLogo from '../../../../assets/images/branding/blue-kbc-logo.png';



// --------------- Assign User Component -------------
const AssignConsultantComponent = () => {

  //
  // Add this to your existing state management section
const [isAssigning, setIsAssigning] = useState(false);

  //
  const user = JSON.parse(sessionStorage.getItem('user'));

  // ----------------------- State Management -----------------------------


  // State Management , consultants compnay
  const [consutlantCompany, setConsultantCompany] = useState([]);
  const [consultantdepartments, setConsultantDepartments] = useState([]);

  // State Management , clients company 
  const [clientCompany, setClientCompany] = useState([]);
  const [clientdepartments, setClientDepartments] = useState([]);

  // Update the departments state to handle multiple selections
  const [selectedDepartments, setSelectedDepartments] = useState([]);

 // Consultant states
 const [selectedConsultantCompany, setSelectedConsultantCompany] = useState("");
 const [selectedConsultantDepartment, setSelectedConsultantDepartment] = useState("");
 const [consultantUsers, setConsultantUsers] = useState([]);
 const [selectedConsultantUser, setSelectedConsultantUser] = useState("");
 const [filteredConsultantDepartments, setFilteredConsultantDepartments] = useState([]);


  // Client states
  const [selectedClientCompany, setSelectedClientCompany] = useState("");
  const [selectedClientDepartment, setSelectedClientDepartment] = useState("");
  const [filteredClientDepartments, setFilteredClientDepartments] = useState([]);

  // State Management - Loading spinner 
  const [isLoading, setIsLoading] = useState(true);


  // State Management - SHE Files 
  const [shepacks, setShePacks] = useState([]);
  const [selectedShePacks, setSelectedShePacks] = useState(''); // Changed to single string

  // State Management - Template 
  const [sheTemplates, setSheTemplates] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([]);

  // State Management - Companies 
  
  const [selectedCompany, setSelectedCompany] = useState("");

  // Update the departments filtering logic

const [selectedDepartment, setSelectedDepartment] = useState("");

const [filteredDepartments, setFilteredDepartments] = useState([]);

  // State Management - Users
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  const [companyCreatedSuccessfullyToaster, setCompanyCreatedSuccessfullyToaster] = useState(false);
  const [showTextEmptyNameError, setShowTextEmptyNameError] = useState(false);
  const [showAssignUserError, setShowAssignUserError] = useState(false);

  const navigate = useNavigate();

  //const filteredDepartments = departments.filter(department => department.companyId === selectedCompany);
  
  // ------------------------------- Use Effects ------------------------

  useEffect(() => {
  const fetchInitialData = async () => {
    setIsLoading(true);
    try {
      // Fetch consultant companies
      await fetchConsultantCompany();
      // Fetch client companies  
      await fetchClientCompany();
    } catch (error) {
      console.error('Error fetching initial data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  

  fetchInitialData();
}, []); // Empty dependency array - runs once on mount

useEffect(() => {
  if (selectedConsultantCompany) {
    fetchConsultantDepartments(selectedConsultantCompany); // Fetch departments for selected company
    setSelectedConsultantDepartment(""); // Reset department selection
    setConsultantUsers([]); // Reset users
    setSelectedConsultantUser(""); // Reset user selection
  } else {
    setConsultantDepartments([]); // Clear departments when no company selected
    setFilteredConsultantDepartments([]);
  }
}, [selectedConsultantCompany]);

useEffect(() => {
  if (selectedClientCompany) {
    fetchClientDepartments(selectedClientCompany); // Fixed: Pass the company ID
    setSelectedClientDepartment(""); // Reset department selection
    setSelectedDepartments([]); // Reset selected departments array
  } else {
    setClientDepartments([]); // Clear departments when no company selected
    setFilteredClientDepartments([]);
  }
}, [selectedClientCompany]);


  //-------------------------------- Functions -------------------------

  const handleConsultantCompanyChange = (e) => {
  const companyId = e.target.value;
  setSelectedConsultantCompany(companyId);
  // Reset dependent fields
  setSelectedConsultantDepartment("");
  setSelectedConsultantUser("");
  setConsultantUsers([]);
};

const handleClientCompanyChange = (e) => {
  const companyId = e.target.value;
  setSelectedClientCompany(companyId);
  // Reset dependent fields
  setSelectedClientDepartment("");
  setSelectedDepartments([]);
};


  const handleDepartmentChange = (e) => {
  const value = e.target.value;
  const isChecked = e.target.checked;

  setSelectedDepartments((prev) => {
    if (isChecked) {
      return [...prev, value];
    } else {
      return prev.filter((item) => item !== value);
    }
  });
};

const handleSelectAllDepartments = (e) => {
  const isChecked = e.target.checked;
  
  if (isChecked) {
    // Select all departments
    const allDepartmentIds = filteredClientDepartments.map(dept => dept.department_id);
    setSelectedDepartments(allDepartmentIds);
  } else {
    // Deselect all departments
    setSelectedDepartments([]);
  }
};

  

  // Functions - fetches SHE Pack
  const fetchConsultantCompany = async () => {
    try {
      const response = await fetch('/api/she-pack/assign-consultant-to-template/department/get-consultant-company');
      const data = await response.json();
      
      // Your API returns the array directly, not wrapped in an object
      if (Array.isArray(data)) {
        setConsultantCompany(data);
      } else {
        console.error('Invalid data format for companies:', data);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  // Fetch departments - using updated API with company_id parameter
  const fetchConsultantDepartments = async (companyId) => {
    try {
      // Add company_id parameter to the URL
      const response = await fetch(`/api/she-pack/assign-consultant-to-template/department/get-consultant-department/${companyId}`);
      const data = await response.json();
      
      // Your API now returns: { success: true, data: departments, company_id: company_id }
      if (data.success && Array.isArray(data.data)) {
        setConsultantDepartments(data.data);
      } else {
        console.error('Invalid data format for departments:', data);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  
  // Fetch companies - using original API
  const fetchClientCompany = async () => {
    try {
      const response = await fetch('/api/she-pack/assign-consultant-to-template/company/get-client-company');
      const data = await response.json();
      if (Array.isArray(data)) {
        setClientCompany(data);
      } else {
        console.error('Invalid data format for companies:', data);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

const fetchClientDepartments = async (companyId) => {
  try {
    const response = await fetch(`/api/she-pack/assign-consultant-to-template/department/get-client-department/${companyId}`);
    const data = await response.json();
    
    // Check for the success property and extract the data array
    if (data.success && Array.isArray(data.data)) {
      setClientDepartments(data.data);
      setFilteredClientDepartments(data.data); // Also update filtered departments
    } else {
      console.error('Invalid data format for departments:', data);
      setClientDepartments([]);
      setFilteredClientDepartments([]);
    }
  } catch (error) {
    console.error('Error fetching departments:', error);
    setClientDepartments([]);
    setFilteredClientDepartments([]);
  }
};


  

  



 

  // Fetch users when consultant department changes
  useEffect(() => {
    if (selectedConsultantDepartment) {
      fetchUsers(selectedConsultantDepartment);
    } else {
      setConsultantUsers([]);
    }
  }, [selectedConsultantDepartment]);

  const fetchUsers = async (departmentId) => {
    try {
      const response = await fetch(`/api/users/${departmentId}`);
      const data = await response.json();
      if (Array.isArray(data)) {
        setConsultantUsers(data);
      } else {
        console.error('Invalid data format for users:', data);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };






  
  
  // Function - fetches she packs
  useEffect(() => {

    const fetchShePacks= async () => {

      setIsLoading(true)

      try {

        const response = await axios.get('/api/manage-users/assign-users/fetch-she-packs');
        setShePacks(response.data);

      } catch (error) {

        console.error('Error fetching SHE Packs :', error);

      } finally {

        setIsLoading(false)

      }
    };

    fetchShePacks();
  }, []);

  
  // Function - fetches she templates linked to the SHE File
  useEffect(() => {
    const fetchTemplates = async () => {
      if (!selectedShePacks) {
        setSheTemplates([]);
        return;
      }
  
      setIsLoading(true);
      try {
        const response = await axios.get(`/api/manage-users/assign-users/fetch-templates/${selectedShePacks}`);
        console.log('Raw API Response:', response.data);
        
        // Check if response.data.templates exists and is an array, otherwise look for response.data
        let templatesArray = response.data.templates || response.data;
        
        // If templates is not an array, convert single object to array
        if (!Array.isArray(templatesArray) && templatesArray) {
          templatesArray = [templatesArray];
        }
        
        console.log('Processed Templates Array:', templatesArray);
        setSheTemplates(templatesArray || []);
        
      } catch (error) {
        console.error('Error fetching Templates:', error);
        setSheTemplates([]);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchTemplates();
  }, [selectedShePacks]);

  useEffect(() => {
    if (selectedDepartment) {
      fetchUsers(selectedDepartment);
    } else {
      setUsers([]);
    }
  }, [selectedDepartment]);

  

  const handleShePackChange = (e) => {
    setSelectedShePacks(e.target.value);
    // Reset templates when SHE pack changes
    setSelectedTemplates([]);
  };

  // Add this function alongside your existing handleSelectAllDepartments function
const handleSelectAllTemplates = (e) => {
  const isChecked = e.target.checked;
  
  if (isChecked) {
    // Select all templates
    const allTemplateIds = sheTemplates.map(template => template.shepack_document_id.toString());
    setSelectedTemplates(allTemplateIds);
  } else {
    // Deselect all templates
    setSelectedTemplates([]);
  }
};

  const handleTemplateChange = (e) => {
    const value = e.target.value;
    const isChecked = e.target.checked;
    
    setSelectedTemplates(prev => {
        if (isChecked) {
            return [...prev, value];
        } else {
            return prev.filter(item => item !== value);
        }
    });
};
  const handleNavigateBack = () => {
    navigate('/she-pack/she-pack-management');
  };

  //
  const handleAssignUser = async (e) => {

    e.preventDefault();

    if (!selectedConsultantUser || !selectedShePacks || selectedTemplates.length === 0) {
      setShowTextEmptyNameError(true);
      return;
    }

    setIsAssigning(true); 


    try {
      const shepack = shepacks.find((c) => c.shepack_id === selectedShePacks);

      const requestBody = {
        userId: selectedConsultantUser,
        company: selectedClientCompany,
        departments: selectedDepartments, // Send array of selected departments
        shepack: {
          shepack_id: selectedShePacks,
          shepack_name: shepack ? shepack.shepack_name : '',
        },
        templates: selectedTemplates,
        created_by: user.user_id,
      };

      const response = await fetch('/api/manage-users/user-management/assign-consultant-to-she-pack', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        setCompanyCreatedSuccessfullyToaster(true);
        setTimeout(() => {
          navigate('/she-pack/she-pack-management');
        }, 3000);
      } else {
        setShowAssignUserError(true);
      }
    } catch (error) {
      console.error('Error assigning user to checklists:', error);
      setShowAssignUserError(true);
    } finally {
      setIsAssigning(false); 
    }
  };
  

  const clearForm = () => {

    setSelectedConsultantCompany('');
    setSelectedConsultantDepartment('');
    setSelectedConsultantUser('');
    setSelectedClientCompany('');
    setSelectedClientDepartment('');
    setSelectedShePacks('');
    setSelectedTemplates([]);
    setShowTextEmptyNameError(false);

  };


  return (
    <div className="component-container">
      <div className="create-checklist-component-container">
        
        <div className="create-company-text-container">

          <div>
          <h2> Legal Compliance - <span className="secondary-color-paragraph">Assign Consultant to Template</span></h2>
                

            <p>
              Assign a client to a template, enabling them to complete and submit the assigned tasks efficiently.
            </p>

            <p>
              <i>
              Select a she pack to assign, then specify the company, department, and user to ensure accurate task delegation.
              </i>
            </p>
          </div>

          
          <div>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="side-menu-logo" />
          </div>
          
          
        </div>

        <div className="navigate-back-button-main-container">
          <div className="navigate-back-button-container">
            <button className="navigate-back-button" onClick={handleNavigateBack}>Back</button>
          </div>
        </div>

      

        <div className="view-checklist-table-container">
          <div className="view-checklist-table-table-container">

            
            <table className="view-checklist-table">

                <colgroup>
                  {/* Remove whitespace between col elements */}
                  <col style={{width: "200px"}}/>{/* Column - SHE File Name */}
                  <col style={{width: "200px"}}/>{/* Column - SHE Template Name */}
                  <col style={{width: "180px"}}/>{/* Column - Company */}
                  <col style={{width: "300px"}}/>{/* Column - Company */}
                  <col style={{width: "500px"}}/>{/* Delete icon column */}
                  <col style={{width: "300px"}}/>{/* Delete icon column */}
                  <col style={{width: "650px"}}/>{/* Delete icon column */}
                  <col style={{width: "300px"}}/>{/* Delete icon column */}
                  
                        
                </colgroup>

              <thead>
                <tr>
                  <th className="table-header">Consultant's Company</th>
                  <th className="table-header">Consultant's Department</th>
                  <th className="table-header">Consultants Name</th>
                  <th className="table-header">Assign to Client's Company</th>
                  <th className="table-header">Assign to Clients Sites</th>
                  

                  <th className="table-header">SHE File Name</th>
                  <th className="table-header">Template Name</th>
                  
                  <th className="table-header">Assign</th>
                </tr>
              </thead>

              <tbody className="view-table-body">
                <tr>

                  {/* Column - Select company  */}
                  <td>
                    <select
                      value={selectedConsultantCompany}
                      onChange={handleConsultantCompanyChange} // Use the fixed handler
                      className="assign-user-checkbox-item"
                      disabled={isLoading}
                    >
                      <option value="">-- Select Company --</option>
                      {consutlantCompany.map(company => (
                        <option key={company.company_id} value={company.company_id}>
                          {company.companyName}
                        </option>
                      ))}
                    </select>
                  </td>
                  
                  {/* Column - Department */}
                  <td>
                    <select
                        value={selectedConsultantDepartment}
                        onChange={e => setSelectedConsultantDepartment(e.target.value)}
                        disabled={!selectedConsultantCompany || isLoading}
                        className="assign-user-checkbox-item"
                      >
                        <option value="">-- Select Department --</option>
                        {consultantdepartments.map(department => (
                          <option key={department.department_id} value={department.department_id}>
                            {department.department_name}
                          </option>
                        ))}
                      </select>
                  </td>

                  {/*Column - Select User */}
                  <td>

                    <select
                      value={selectedConsultantUser}
                      onChange={e => setSelectedConsultantUser(e.target.value)}
                      disabled={!selectedConsultantDepartment}
                    >
                      <option value="">-- Select User --</option>

                        {consultantUsers.map(user => (

                          <option key={user.user_id} value={user.user_id}>
                            {user.userName} {user.userSurname}
                          </option>

                        ))}

                    </select>

                  </td>

                  {/* Column - Select company  */}
                  <td>

                    <select
                      value={selectedClientCompany}
                      onChange={handleClientCompanyChange} // Use the fixed handler
                      className="assign-user-checkbox-item"
                      disabled={isLoading}
                    >
                      <option value="">-- Select Company --</option>
                      {clientCompany.map(company => (
                        <option key={company.company_id} value={company.company_id}>
                          {company.companyName}
                        </option>
                      ))}
                    </select>

                  </td>
                  
                  {/* Column - Department */}
                  <td>
  <div className="sites-departments-column-main-container">
    {/* Show loading state */}
    {isLoading ? (
      <div className="loading-spinner-assign-checklist-container">
        <LiaSpinnerSolid className="lia-spin-solid-icon" />
      </div>
    ) : !selectedClientCompany ? (
      <p>Please select a company first</p>
    ) : clientdepartments.length === 0 ? (
      <p>No departments available</p>
    ) : (
      <>
        {/* Select All Departments Checkbox */}
        <div className="sites-departments-select-all-column-main-container">
          <label htmlFor="select-all-departments"><strong>Select All</strong></label>
          <input
            type="checkbox"
            id="select-all-departments"
            checked={selectedDepartments.length === clientdepartments.length && clientdepartments.length > 0}
            onChange={handleSelectAllDepartments}
            disabled={clientdepartments.length === 0}
          />
        </div>
        
        {/* Individual Department Checkboxes */}
        {clientdepartments.map((department) => (
          <div key={department.department_id} className="sites-departments-select-all-column-main-container">
            <label>{department.department_name}</label>
            <input
              type="checkbox"
              value={department.department_id}
              checked={selectedDepartments.includes(department.department_id)}
              onChange={handleDepartmentChange}
            />
          </div>
        ))}
      </>
    )}
  </div>
</td>

                  

                  {/* Table Row - She file  */}
                  <td> 
                    
                    <select
                      value={selectedShePacks}
                      onChange={handleShePackChange}
                    >
                      <option value="">-- Select SHE file --</option>
                      {shepacks.map(shePack => (
                        <option key={shePack.shepack_id} value={shePack.shepack_id}>
                          {shePack.shepack_name}
                        </option>
                      ))}
                    </select>    
                                 
                  </td>

                  
                  {/* Table Row - Templates */}
                  <td>
  {isLoading ? (
    <div className="loading-spinner-assign-checklist-container">
      <LiaSpinnerSolid className="lia-spin-solid-icon" />
    </div>
  ) : (
    <div className="assign-user-checkbox-container">
      {console.log('Current sheTemplates state:', sheTemplates)}
      {!sheTemplates || sheTemplates.length === 0 ? (
        <p>Currently no Templates available</p>
      ) : (
        <div className="sites-departments-column-main-container">
          {/* Select All Templates Checkbox */}
          <div className="sites-departments-select-all-column-main-container">
            <label htmlFor="select-all-templates"><strong>Select All</strong></label>
            <input
              type="checkbox"
              id="select-all-templates"
              checked={selectedTemplates.length === sheTemplates.length && sheTemplates.length > 0}
              onChange={handleSelectAllTemplates}
            />
          </div>
          
          {/* Individual Template Checkboxes */}
          {sheTemplates.map((template) => (
            <div key={template.shepack_document_id} className="sites-departments-select-all-column-main-container">
              <label>{template.shepack_document_name}</label>
              <input
                className="assign-user-checkbox"
                type="checkbox"
                id={template.shepack_document_id}
                value={template.shepack_document_id}
                checked={selectedTemplates.includes(template.shepack_document_id.toString())}
                onChange={handleTemplateChange}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )}
</td>

                  

                  

                  {/* Column - Assign user */}
                  {/* Column - Assign user */}
<td>
  <MdAssignmentAdd 
    onClick={!isAssigning ? handleAssignUser : undefined} 
    className="assign-user-assign-icon"
    style={isAssigning ? { 
      opacity: 0.5, 
      cursor: 'not-allowed', 
      pointerEvents: 'none' 
    } : {}}
  />
</td>
                </tr>
              </tbody>
            </table>
          </div>

          {showTextEmptyNameError && (
            <p className="error-text">Error! Empty fields, please fill in all fields and select at least one checklist.</p>
          )}

          <div className="assign-user-button-container-container">
            <div className="assign-user-button-container">
              <button className="assign-user-button" type='button' onClick={clearForm}>Reset</button>
            </div>
          </div>
        </div>
      </div>

      {showAssignUserError && 
        <ToastError 
          toasterError='Error Assigning User'
        />
      }

      {companyCreatedSuccessfullyToaster && 
        <CreatedSuccessfullToaster 
          successToasterTitle="Assigned Successfully" 
          successToasterMessage="Consultant assigned to template successfully. "
        />
      }
    </div>
  );
};

export default AssignConsultantComponent;